<div class="container-fluid row col-12 no-gutters">
  <div class="col-xl-9 col-md-9 col-sm-12 col-12 no-gutters">
    <div class="col-xl-9 col-md-9 col-sm-12 col-12 m-auto no-gutters">
      <h6 class="col-12 mb-3 text-normal"><strong>Application
          Description</strong>
      </h6>
      <div class="col-12 text-normal mb-3">Clear Orbit is used within Renewables as a PO Collaboration 
        application. PO acceptance, delivery dates are exchanged.
      </div>
      <h6 class="col-12 text-normal"><strong>Registration
          Question</strong>
      </h6>
      <div class="row col-12 mt-3 no-gutters text-normal">
        <p>
          Please follow this <a href="https://registration.gepower.com/catalog" class="text-highlight">
            LINK
          </a>
          to register this application
        </p>
      </div>
    </div>
  </div>
  <div class="col-sm-12 col-md-3 col-xl-3 no-gutters">
    <div class="row no-gutters col-12 align-items-center justify-content-center d-none d-sm-block">
      <button class="btn btn-primary button btn-vernova col-12" style="font-size: 18px;" (click)="goToApplication()">
        <span>
          Go To Application
          <i class='fa fa-sign-out pl-2' style="color: #fff;"></i>
        </span>
      </button>
    </div>
    <hr>
    <div class="col-12">
      <h6>
        <strong class="mt-3 text-lable">
          Support
        </strong>
      </h6>
      <div class="col-12 mt-3 p-0 text-normal d-block d-sm-none">
        <button class="btn btn-primary btn-vernova button col-12" style="font-size: 18px;" (click)="goToApplication()">
          <span>
            Go To Application
            <i class='fa fa-sign-out pl-2' style="color: #fff;"></i>
          </span>
        </button>
        <hr>
      </div>
      <div class="col-12 mt-3 p-0 text-normal">
        eSourcing Production Support (GE Gas Power) (<a href="mailto:psesourps@ps.ge.com" class="text-highlight" style="word-wrap: break-word;">psesourps@ps.ge.com</a>)
      </div>
    </div>
    <hr>
  </div>
</div>